<template>
    <div id="container" type="vdpp">
        <div class="page page-sell" v-ga:request="{pageType:'vsell', state: {}}" v-ga:page="{pageType:'vsell', glb: glb, state: {}}">
            <mvtHeader :geoInfo="sell.geo"/>
            <sellWelcome></sellWelcome>
            <section class="inline large" v-if="snapshotData" id="snapshotPanel">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <mvtSnapshot :data="snapshotData"></mvtSnapshot>
                </div>
            </section>
            <section class="inline bg-default large">
                <div class="grid fixed fixed-max-sm gap-3 xs-grid-cols-1 sm-grid-cols-3">
                    <div class="wrap">
                        <h2 class="f0 text-bold">Our Selling Options <span v-if="glb.geo && glb.geo.city">in {{glb.geo.city}}</span></h2>
                        <div class="f3 text-bold">Our <span class="text-brand">{{local}} Agents</span> Will Deliver the Best Solution for Your Needs</div>
                    </div>
                    <div class="inline corner outline bg-default grid gap-3 xs-grid-cols-1">
                        <img class="w-100" :src="`${glb.cdnUrl}vimages/web-cashoffer.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1">
                            <div>
                                <div><b class="text-bold text-brand">Cash Offer</b> <span class="tag safe active">New</span></div>
                                <div><b class="text-bold f4">Speed, Convenience, and Certainity</b></div>
                            </div>
                            <div><i class="icon-check-circle-outside"></i> Sell your home quickly</div>
                            <div><i class="icon-check-circle-outside"></i> Enables you to sell before buying</div>
                            <div><i class="icon-check-circle-outside"></i> No staging or preparation needed</div>
                        </div>
                        <div>
                            <b>Speak with a partner to see if a cash offer is right for you.</b>
                        </div>
                        <button class="btn primary regular w-100 self-bottom" type="button" @click="sendCashOffer">Get a Cash Offer</button>
                    </div>
                    <div class="inline corner outline bg-default grid gap-3 xs-grid-cols-1">
                        <img class="w-100" :src="`${glb.cdnUrl}vimages/web-homesale.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1">
                            <div>
                                <div><b class="text-bold text-brand">Selling</b></div>
                                <div><b class="text-bold f4">Receive the Most for Your Home</b></div>
                            </div>
                            <div><i class="icon-check-circle-outside"></i> Work within your timeline</div>
                            <div><i class="icon-check-circle-outside"></i> Find ways to increase your home's value</div>
                            <div><i class="icon-check-circle-outside"></i> Price your home competitively</div>
                        </div>
                        <div>
                            <b>Speak with a local Real Estate Agent expert to discuss your goals.</b>
                        </div>
                        <button class="btn primary regular w-100 self-bottom" type="button" @click="sendSellLead">Sell My Home</button>
                    </div>
                    <div class="inline corner outline bg-default grid gap-3 xs-grid-cols-1">
                        <img class="w-100" :src="`${glb.cdnUrl}vimages/web-deal.svg`"  loading="lazy" >
                        <div class="grid xs-grid-cols-1">
                            <div>
                                <div><b class="text-bold text-brand">Buying and Selling</b></div>
                                <div><b class="text-bold f4">Seamless Transactions</b></div>
                            </div>
                            <div><i class="icon-check-circle-outside"></i> Coordinate transactions for efficiency</div>
                            <div><i class="icon-check-circle-outside"></i> Fewer financial hurdles, greater peace</div>
                            <div><i class="icon-check-circle-outside"></i> Simplifies logistics, adds convenience</div>
                        </div>
                        <div>
                            <b>Speak with a local Real Estate Agent expert to coordinate.</b>
                        </div>
                        <button class="btn primary regular w-100 self-bottom"  type="button" @click="sendSellLead">Connect with an Agent</button>
                    </div>
                </div>
            </section>
            <sellContent :local="local"></sellContent>

            <mvtFooter :geoInfo="sell.geo"/>
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-sell.js"></script>